/**
 * Dynamically adjusts height of .seven-fifty-height elements based on screen width
 * Increases by 20px for every 100px above 2400px screen width
 */
function adjustSevenFiftyHeight() {
  // Base screen width to start adjustments from
  const baseWidth = 2400;
  
  // Base height value at 2400px
  const baseHeight = 750;
  
  // Get current window width
  const currentWidth = window.innerWidth;
  
  // Calculate the new height
  let newHeight = baseHeight;
  
  // Only make adjustments if screen is wider than base width
  if (currentWidth > baseWidth) {
    // Calculate how many 100px increments we're above the base width
    const increments = Math.floor((currentWidth - baseWidth) / 100);
    
    // Add 20px per 100px increment
    newHeight = baseHeight + (increments * 20);
  }
  
  // Apply the new height to all elements with .seven-fifty-height class
  const heightElements = document.querySelectorAll('.seven-fifty-height');
  heightElements.forEach(element => {
    element.style.height = `${newHeight}px`;
  });
}

// Run the function on page load
document.addEventListener('DOMContentLoaded', adjustSevenFiftyHeight);

// Update on window resize
window.addEventListener('resize', adjustSevenFiftyHeight);